import React, { useEffect } from "react";
import { useHotkeysContext } from "react-hotkeys-hook";

import { Modal, ModalProps } from "new-components/modals/Modal";

interface CustomModalProps extends ModalProps {}

export function CustomModal({ open, ...modalProps }: CustomModalProps) {
  const { disableScope, enableScope } = useHotkeysContext();

  useEffect(() => {
    if (open) {
      disableScope("review");
      enableScope("dummy");
    } else {
      enableScope("review");
    }

    return () => {
      enableScope("review");
    };
  }, [open, disableScope, enableScope]);

  return <Modal open={open} {...modalProps} />;
}
